import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store';

// Check if running on admin subdomain
const isAdminSubdomain = () => {
  const hostname = window.location.hostname;
  return hostname.startsWith('admin.') || hostname.startsWith('admin-');
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  
  if (!isAuthenticated) {
    // Redirect to appropriate login based on subdomain
    const loginPath = isAdminSubdomain() ? '/login' : '/admin/login';
    return <Navigate to={loginPath} replace />;
  }
  
  return children;
};

export default ProtectedRoute;
